var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.460938 29.8939C0.460938 19.7102 0.460938 14.6184 2.44282 10.7287C4.18615 7.30725 6.96789 4.5255 10.3893 2.78218C14.279 0.800293 19.3709 0.800293 29.5546 0.800293H51.7579C61.9416 0.800293 67.0335 0.800293 70.923 2.78218C74.3444 4.5255 77.1262 7.30725 78.8696 10.7287C80.8515 14.6184 80.8515 19.7102 80.8515 29.8939V52.0972C80.8515 62.281 80.8515 67.3728 78.8696 71.2623C77.1262 74.6838 74.3444 77.4656 70.923 79.2089C67.0335 81.1908 61.9416 81.1908 51.7579 81.1908H29.5546C19.3709 81.1908 14.279 81.1908 10.3893 79.2089C6.96789 77.4656 4.18615 74.6838 2.44282 71.2623C0.460938 67.3728 0.460938 62.281 0.460938 52.0972V29.8939Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.665 57.4651L40.4978 50.355H29.5855L27.4182 57.4651H20.6123L31.1444 27.4658H38.7488L49.3189 57.4651H42.665ZM38.8628 45.032C36.8477 38.6062 35.745 34.9561 35.4789 34.1197C35.2127 33.2832 35.0606 32.5988 34.9466 32.1045C34.4903 33.8535 33.1976 38.188 31.1444 45.032H38.8628Z",
    fill: "#501A03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4746 28.7207C52.4746 26.7055 53.6153 25.679 55.8586 25.679C58.1019 25.679 59.2425 26.7055 59.2425 28.7207C59.2715 29.1327 59.2118 29.5461 59.0675 29.9331C58.9232 30.32 58.6977 30.6716 58.406 30.964C58.0596 31.2677 57.6554 31.4984 57.2176 31.6421C56.7799 31.7859 56.3176 31.8397 55.8586 31.8005C53.6153 31.8005 52.4746 30.7739 52.4746 28.7207ZM58.9764 57.4653H52.9309V34.6521H59.1665L58.9764 57.4653Z",
    fill: "#501A03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.72b5d48e373126c5fec3934c9ef71f33.svg";
export { ForwardRef as ReactComponent };